import Cookies from "js-cookie";
import Router from "next/router";
import dayjs from "dayjs";
import {
  ERROR_MESSAGE,
  PERSONAL_EMAILS,
  MOBILE_TYPE,
  SEEKER_URL,
  WHATSAPP_URL,
  WHATSAPP_WEB_URL,
  STORAGE_ITEMS,
  DIRECT_APPLIES,
  DATABASE_MATCHES,
  ACTIONED,
  HIRED,
  REJECTED,
  CLOSED,
  EXPIRED,
  PREMIUM_JOB,
  TEAM_JOINING_STATUS,
  FB_PIXEL_ID
} from "./constants";
import makeAjaxRequest from "./makeAjaxRequest";
import fetchUrl from "./fetchUrl";
import {
  CLIENT_DETAILS,
  CONTACT_DETAILS,
  DASHBOARD,
  DOCUMENT_VERIFICATION,
  JOB_POSTING_FORM,
  LOADING_PAGE,
  LOGIN,
  PROFILE,
  Routes
} from "../routes/RouteConstants";
import { getDeviceType } from "../redux/commonActions";
import { REC_ERROR_CODE, NETWORK_ERROR_CODE } from "./loggingConstants";
import { StorageService } from "./StorageService";
import ClmGetTrackingService from "./ClmTrackingService";
import { setCookie } from "./cookie";
import LogService from "./LogService";
import CREDIT_EVENTS from "../utils/CreditEvents";
import { reportException } from "../logging";
import useRedirectionStore from "zustandStores/redirectionStore";
import { getQueryClient } from "./queryClientService";
import { clearChatbotStorage } from "../components/FloatingChatbot/utils/storageHelpers";

export function getUrlExtension(url) {
  return url.split(/[#?]/)[0].split(".").pop().trim();
}

/**
 * Get cookie domain based on hostname (client-side only)
 * @returns {string|undefined} - Returns ".jobhai.com" if hostname includes "jobhai.com", otherwise undefined
 */
export const getCookieDomain = () => {
  if (!process.browser || !window.location || !window.location.hostname) {
    return undefined;
  }

  const hostname = window.location.hostname;

  if (!hostname || typeof hostname !== "string" || !hostname.trim()) {
    return undefined;
  }

  return hostname.includes("jobhai.com") ? ".jobhai.com" : undefined;
};

export function detectMobile() {
  if (process.browser) {
    if (window.innerWidth <= 576) {
      return true;
    } else {
      return false;
    }
  }
}
export function formattedDuration(string) {
  if (string) {
    let s = "";
    const date = new Date(string);
    const today = new Date();
    const elapsed = today.getTime() - date.getTime();
    const days = Math.ceil(elapsed / 8.64e7);
    if (days <= 6) {
      if (days == 0) {
        s = "1 day";
      } else {
        s = `${days} ${days > 1 ? " days" : " day"}`;
      }
    }
    if (days > 6 && days < 49) {
      const weeks = Math.ceil(days / 7);
      s = `${weeks} ${weeks > 1 ? " weeks" : " week"}`;
    }
    if (days >= 49 && days < 150) {
      s = " very short span";
    }
    if (days > 150) {
      s = "short span";
    }
    return `within ${s}`;
  }
}

export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "";
  }
}

export function getFirstWord(string) {
  if (string) {
    let arrString = string.split(" ");
    let fName = arrString.length > 0 ? arrString[0] : string;
    return capitalizeFirstLetter(fName);
  } else return "Recruiter";
}
export function experienceText(months) {
  const yearsAndMonths =
    ((months / 12) | 0) + " years and " + (months % 12) + " months";
  return yearsAndMonths;
}

export function isTimeScope() {
  var minHours = new Date("July 01, 2000 09:00:00").getHours();
  var maxHours = new Date("July 01, 2000 20:00:00").getHours();
  var currentHours = new Date().getHours();
  return currentHours < minHours || currentHours > maxHours;
}

export const isEmpty = obj =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length;

// Function to set device type(Desktop/Mobile) in reducer from server side
export function setDeviceType(req, reduxStore) {
  let userAgent;

  if (req) {
    userAgent = req.headers["user-agent"];
  } else {
    userAgent = navigator.userAgent;
  }

  let isMobile = Boolean(
    userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    )
  );

  if (isMobile) {
    reduxStore.dispatch(getDeviceType("mobile"));
  } else {
    reduxStore.dispatch(getDeviceType("desktop"));
  }
}

export const isRecommended = selectedStatus =>
  selectedStatus === "reco_recommended" ||
  selectedStatus === "reco_r_invited" ||
  selectedStatus === "reco_r_called" ||
  selectedStatus === "reco_r_message" ||
  selectedStatus === "reco_r_viewed" ||
  selectedStatus === "reco_r_impression" ||
  selectedStatus === "reco_r_unlocked" ||
  selectedStatus === "reco_r_download";

export const getSkills = (metaData, jobList, jobId) => {
  const job = jobList.filter(item => item.job_id == jobId);
  const categoryId = job.length ? job[0].category_id : 0;
  const jobCategory = metaData.categories.filter(item => item.id == categoryId);
  return jobCategory.length ? jobCategory[0].skills : [];
};

export const setSkillsFilter = skills =>
  skills.map(item => {
    return { value: item.id, label: item.label };
  });

export const isEditableField = (fieldList, key) => {
  const field =
    Array.isArray(fieldList) && fieldList.find(item => item.field_name === key);
  return field && field.type === "UNEDITABLE";
};

export function isMobileDevice() {
  if (process.browser) {
    if (window) {
      return window.innerWidth <= 576;
    } else return false;
  }
}

export const sumOfDeviceId = recDeviceId => {
  let sum = 0;

  for (let i = 0; i < recDeviceId.length; ++i) {
    const n = recDeviceId[i];

    if (n !== "-") {
      sum += parseInt(n, 16);
      recDeviceId;
    }
  }

  return sum;
};

export function getErrorMessage(error) {
  let errorMessage = "";
  const errorResponse = error && error.response;
  if (errorResponse) {
    if (error.response.data) {
      const {
        details = {},
        status = "",
        error = ""
      } = errorResponse.data ? errorResponse.data : {};
      if (status === "INVALID_INPUT") {
        const { body = {} } = details;
        if (isObject(body)) {
          const errorList = Object.values(body);
          errorMessage = errorList.length > 0 ? errorList[0] : error;
        } else {
          errorMessage = error;
        }
      } else {
        errorMessage = error;
      }
    } else {
      errorMessage = ERROR_MESSAGE;
    }
  } else {
    errorMessage = ERROR_MESSAGE;
  }
  return errorMessage;
}

export function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function candidateCount(tabs = []) {
  if (tabs.length) {
    let count = tabs.reduce((prev, next) => prev + next.count, 0);
    return count;
  }
}

export function encodeQueryData(baseURL, data) {
  const query = [];
  for (let key in data) {
    if (data[key]) {
      query.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
    }
  }
  if (query.length) {
    return baseURL + "?" + query.join("&");
  }
  return baseURL;
}

export function recruiterToSeekerUTM() {
  let url = "";
  if (typeof window !== "undefined") {
    url = window.location.search;
  }

  const urlParams = new URLSearchParams(url);
  let utm_source = urlParams.get("utm_source") || "";
  let utm_medium = urlParams.get("utm_medium") || "";
  let utm_campaign = urlParams.get("utm_campaign") || "";
  let utm_content = urlParams.get("utm_content") || "";
  let utm_term = urlParams.get("utm_term") || "";

  const utmData = {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term
  };

  const encodedURL = encodeQueryData(SEEKER_URL, utmData);

  return encodedURL;
}

export function stringToText(str = "") {
  var i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
}

export function chunkify(a, n, balanced) {
  if (n < 2) return [a];

  var len = a.length,
    out = [],
    i = 0,
    size;

  if (len % n === 0) {
    size = Math.floor(len / n);
    while (i < len) {
      out.push(a.slice(i, (i += size)));
    }
  } else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / n--);
      out.push(a.slice(i, (i += size)));
    }
  } else {
    n--;
    size = Math.floor(len / n);
    if (len % size === 0) size--;
    while (i < size * n) {
      out.push(a.slice(i, (i += size)));
    }
    out.push(a.slice(size * n));
  }

  return out;
}

export function truncate(str = "") {
  if (str)
    return str.length > 20
      ? str.substr(0, 4) + "..." + str.substr(str.length - 8, str.length)
      : str;
  else return "";
}

export function isDocumentUnverified(profileData) {
  return (
    profileData &&
    profileData.company &&
    profileData.company.document_status === "no_document"
  );
}

export const getDocumentStatus = profileData => {
  if (profileData && profileData.company) {
    return profileData.company.document_status;
  } else return "";
};

export function shouldEmailVerify(profileData) {
  if (profileData) return !profileData.is_email_verified;
  else return false;
}

function toClientDetails(job_id) {
  Router.push({
    pathname: CLIENT_DETAILS,
    query: { job_id }
  });
}

function toContactDetails(job_id) {
  StorageService.setContactDetailsJobId(job_id);
  Router.push({
    pathname: CONTACT_DETAILS,
    query: { job_id }
  });
}

function toEmailVerification(job_id, profile = {}) {
  Router.push({
    pathname: Routes.VERIFY_EMAIL,
    query: { job_id }
  });
}

export function pageAfterJobPosting(userProfile, jobData) {
  const { job_id, isDraft } = jobData || {};
  const profile = userProfile || {};
  if (isDraft) {
    // override all cases for draft jobs
    LogService.log(CREDIT_EVENTS.DRAFT_JOB_CREATED, {
      jobId: job_id
    });
    Router.push({
      pathname: Routes.CHECKOUT,
      query: {
        jobId: job_id,
        flow: "job-purchase"
      }
    });
    return;
  }
  // case 1 : New user first time login
  if (!profile.is_verified_recruiter && !profile.is_soft_profile_completed) {
    toContactDetails(job_id);
    return;
  } else {
    if (profile.is_consultant == null) {
      toContactDetails(job_id);
      return;
    }
    // case 2 : Email Unverified but Document Verified user
    else if (!profile.is_email_verified && !isDocumentUnverified(profile)) {
      toEmailVerification(job_id, profile);
      return;
    }

    // case 3 : Email Verified but Document Unverified user
    else if (profile.is_email_verified && isDocumentUnverified(profile)) {
      Router.push(DOCUMENT_VERIFICATION);
      return;
    }

    // case 4 :  Email Unverified & Document Unverified user
    else if (!profile.is_email_verified && isDocumentUnverified(profile)) {
      toEmailVerification(job_id, profile);
      return;
    }

    // case 5 : Email Verified & Document verified user and part of new system
    else if (
      profile.is_email_verified &&
      !isDocumentUnverified(profile) &&
      profile.is_part_of_new_system
    ) {
      Router.push(Routes.DASHBOARD);
      return;
    }
    // case 5 : Email Verified & Document verified user
    else if (profile.is_email_verified && !isDocumentUnverified(profile)) {
      Router.push(Routes.OVERVIEW);
      return;
    }
  }
}

export function pageAfterClientDetail(profile = {}, jobId = "") {
  if (!profile.is_email_verified && !isDocumentUnverified(profile)) {
    // case 2 : Email Unverified but Document Verified user
    toEmailVerification(jobId, profile);
    return;
  }
  // case 3 : Email Verified but Document Unverified user
  else if (profile.is_email_verified && isDocumentUnverified(profile)) {
    Router.push(DOCUMENT_VERIFICATION);
    return;
  }
  // case 4 :  Email Unverified & Document Unverified user
  else if (!profile.is_email_verified && isDocumentUnverified(profile)) {
    toEmailVerification(jobId, profile);
    return;
  }
  // case 5 : Email Verified & Document verified user
  else if (profile.is_email_verified && !isDocumentUnverified(profile)) {
    Router.push(Routes.OVERVIEW);
    return;
  }
}

export function pageAfterEmailOtpVerify(profile = {}) {
  if (isDocumentUnverified(profile)) {
    Router.push({
      pathname: DOCUMENT_VERIFICATION,
      query: { later: Routes.OVERVIEW }
    });
    return;
  }
  Router.push(Routes.OVERVIEW);
}

export function pageAfterEmailVerify(profile = {}, later) {
  // this function can be called on "Do it later" or 5 minutes After Email Verified
  // case 1 : New user first time login
  if (later) {
    if (later === DOCUMENT_VERIFICATION) {
      Router.push({
        pathname: later,
        query: { later: PROFILE }
      });
    } else if (
      getDocumentStatus(profile) === "no_document" ||
      getDocumentStatus(profile) === "rejected"
    ) {
      Router.push({
        pathname: DOCUMENT_VERIFICATION,
        query: { later: PROFILE }
      });
    } else {
      Router.push(later);
    }
  } else if (
    !profile.is_verified_recruiter &&
    !profile.is_soft_profile_completed
  ) {
    Router.push(DOCUMENT_VERIFICATION);
    return;
  } else {
    if (!profile.is_email_verified && !isDocumentUnverified(profile)) {
      // case 2 : Email Unverified but Document Verified user
      Router.push(Routes.OVERVIEW);
      return;
    }
    // case 3 : Email Verified but Document Unverified user -> will never happen but if a user types the page he should navigate to Dashboard
    else if (profile.is_email_verified && isDocumentUnverified(profile)) {
      Router.push(Routes.OVERVIEW);
      return;
    }
    // case 4 :  Email Unverified & Document Unverified user
    else if (!profile.is_email_verified && isDocumentUnverified(profile)) {
      Router.push(DOCUMENT_VERIFICATION);
      return;
    }
    // case 5 : Email Verified & Document verified user -> will never happen but if a user types the page he should navigate to Dashboard
    else if (profile.is_email_verified && !isDocumentUnverified(profile)) {
      Router.push(Routes.OVERVIEW);
      return;
    }
  }
}

export function pageAfterLoading(data) {
  const { landingUrl, setLandingUrl } = useRedirectionStore.getState();
  const returnLandingUrl = landingUrl;
  const reqInProgressOrFailed =
    data?.recentRecruiterRequest?.status === TEAM_JOINING_STATUS.IN_PROGRESS ||
    data?.recentRecruiterRequest?.status === TEAM_JOINING_STATUS.FAILED;
  const reqPending =
    data?.recentRecruiterRequest?.status === TEAM_JOINING_STATUS.PENDING;
  const teamJoiningId =
    data?.recentRecruiterRequest?.teamIdDetails?.encryptedData;
  if (data) {
    if (reqPending && teamJoiningId) {
      return `${Routes.TEAM_JOINING_FORM}?team_joining_id=${teamJoiningId}`;
    } else if (
      !reqPending && // do not show gtm if req is pending
      (reqInProgressOrFailed || !data?.shownGTMBanner)
    ) {
      return Routes.WELCOME;
    } else {
      if (!data.is_soft_profile_completed && !data.contact_details_completed) {
        setCookie("first_time_user", true);
        return JOB_POSTING_FORM;
      } else if (
        data.is_soft_profile_completed &&
        !data.contact_details_completed
      ) {
        setCookie("first_time_user", true);
        return CONTACT_DETAILS;
      } else if (
        data.is_soft_profile_completed &&
        data.contact_details_completed &&
        !data.email
      ) {
        setCookie("first_time_user", true);
        return Routes.VERIFY_EMAIL;
      } else if (landingUrl) {
        setLandingUrl(null);
        return returnLandingUrl;
      } else if (Router.pathname === LOADING_PAGE) {
        return Routes.OVERVIEW;
      } else {
        return null;
      }
    }
  }
  return null;
}

export function unverifiedBannerLabel(profile = {}) {
  const accountText = shouldEmailVerify ? "account" : "company";

  if (
    !profile.is_email_verified &&
    !isDocumentUnverified(profile) &&
    getDocumentStatus(profile) !== "rejected"
  ) {
    // case 1 : Email Unverified but Document Verified user
    return {
      h1: `Verify your email to make your job active!`,
      h2: "Email verification is done to have only genuine jobs on Job Hai",
      isBenefit: true
    };
  }
  // case 2 : Email Verified but Document Unverified user -> will never happen but if a user types the page he should navigate to Dashboard
  else if (profile.is_email_verified && isDocumentUnverified(profile)) {
    return {
      h1: `Verify your company to make your job active!`,
      h2: "Company document verification is done to have only genuine jobs on Job Hai",
      isBenefit: true
    };
  }
  // case 3 :  Email Unverified & Document Unverified user
  else if (!profile.is_email_verified && isDocumentUnverified(profile)) {
    return {
      h1: `Verify your email and company to make your job active!`,
      h2: "Email id & Company Document verification is done to have only genuine jobs on Job Hai",
      isBenefit: true
    };
  }
  // case 4 : Email Unerified & Document Rejected
  else if (
    !profile.is_email_verified &&
    getDocumentStatus(profile) === "rejected"
  ) {
    return {
      h1: "We could not verify your email and company document",
      h2: rejectReasons(profile),
      isBenefit: true
    };
  }
  // case 5 : Email Verified & Document Rejected
  else if (
    profile.is_email_verified &&
    getDocumentStatus(profile) === "rejected"
  ) {
    return {
      h1: "We could not verify your company document",
      h2: rejectReasons(profile),
      isBenefit: true
    };
  }
}

export const getVerifiedInfo = (profileData = {}) => {
  let verifyCta = "account";
  if (profileData) {
    if (!profileData.is_email_verified && isDocumentUnverified(profileData)) {
      verifyCta = "account";
    } else if (!profileData.is_email_verified) {
      verifyCta = "email";
    } else if (
      isDocumentUnverified(profileData) ||
      getDocumentStatus(profileData) === "rejected"
    ) {
      verifyCta = "document";
    }
  }
  return verifyCta;
};

export const getVerifiedLabel = (ctaTitle = "account") => {
  return ctaTitle === "account" ? "email and company document" : ctaTitle;
};

export function rejectReasons(profile = {}, isViewer = false) {
  if (profile && profile.company) {
    const { doc_reject_reason = {} } = profile.company;
    const { other_reason = "", viewer_reason = "" } = doc_reject_reason;
    return isViewer ? viewer_reason : other_reason;
  }
}

export const indianNumberFormat = (x = "") => {
  if (x) {
    x = x.toString();
    let lastThree = x.substring(x.length - 3);
    const otherNumbers = x.substring(0, x.length - 3);

    if (otherNumbers != "") {
      lastThree = "," + lastThree;
    }

    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  } else return x;
};

export const allowSendAppLink = () => {
  const smsCount = Cookies.get("rec_sms_count")
    ? Number(Cookies.get("rec_sms_count")) + 1
    : 1;
  Cookies.set("rec_sms_count", smsCount, {
    expires: 0.0208333, // 0.0208333 = 30 minutes
    path: "/"
  });
  return smsCount < 4 ? true : false;
};

export const setOtpCount = () => {
  const otpCount = Cookies.get("rec_otp_count")
    ? Number(Cookies.get("rec_otp_count")) + 1
    : 1;
  const cookieDomain = getCookieDomain();
  Cookies.set("rec_otp_count", otpCount, {
    expires: 0.0208333, // 0.0208333 = 30 minutes,  0.00347222 = 5 minutes,
    path: "/",
    ...(cookieDomain && { domain: cookieDomain })
  });
};

export const signOut = (redirect = true) => {
  const cookieDomain =
    process.browser && window.location.hostname.includes("jobhai.com")
      ? ".jobhai.com"
      : undefined;

  // Remove cookies that were set WITH domain
  Cookies.remove("rec_access_token", { domain: cookieDomain });
  Cookies.remove("firebase_token", { domain: cookieDomain });
  Cookies.remove("is_returning_user", { domain: cookieDomain });
  Cookies.remove("rec_otp_count", { domain: cookieDomain });
  Cookies.remove("isAutoSave", { domain: cookieDomain });

  Cookies.remove("rec_access_token");
  Cookies.remove("firebase_token");
  Cookies.remove("is_returning_user");
  Cookies.remove("rec_otp_count");
  Cookies.remove("isAutoSave");
  // Remove cookies that were set WITHOUT domain
  Cookies.remove("phone");
  Cookies.remove("cmpVisitCount");

  // Clear chatbot storage (thread ID and resource ID) before clearing all localStorage
  clearChatbotStorage();

  localStorage.clear();
  ClmGetTrackingService().logout();
  StorageService.removeFromStorage(STORAGE_ITEMS.EVENT_TRACKING_DATA_REC);
  if (redirect)
    Router.push(LOGIN).then(() => {
      window.scrollTo(0, 0);
    });
  else {
    window.location.href = "/hire/recruiter-login";
  }
};

export const logoutAllDevices = (error, isLogoutAllDevices = true) => {
  if (
    error &&
    error.response &&
    error.response.status == 403 &&
    isLogoutAllDevices
  ) {
    // Clear React Query cache before signing out
    const queryClient = getQueryClient();
    if (queryClient) {
      queryClient.clear();
    }
    signOut();
  }
  throw error;
};

export const getFormattedValue = (
  string,
  isNumber = false,
  isPhone = false,
  alphabetOnly = false,
  alphaNumericSpace = false
) => {
  if (string) {
    let value = string.replace(/(<([^>]+)>)/gi, ""); // Added To Remove Tags
    value = removeEmojis(value);
    if (isNumber) value = value.replace(/\D/, "");
    if (isPhone) value = value.replace(/^0/, "");
    if (alphabetOnly) value = value.replace(/[^A-Z a-z]/gi, "");
    if (alphaNumericSpace) value = value.replace(/[^A-Za-z0-9 ]/gi, "");
    return value;
  } else {
    return "";
  }
};

export const isValidUrl = url => {
  if (url) {
    let string = url.toLowerCase();
    const www = string.substring(0, 4); // if url start from www.
    const http = string.substring(0, 7); // if url start from http://
    const https = string.substring(0, 8); // if utl start from https://

    // Regx to check http://wwww.domain.com or https://wwww.domain.com or http://domain.com or https://domain.com or www.domain.com
    const regx =
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?/;
    // To check special charactor on url
    var specialCharRegx = /[!$%^&*()+|~=`{}\[\]";'<>?,]/;

    // To check http:// or https:// or www in  url
    if (!(www == "www." || http == "http://" || https == "https://")) {
      return false;
    } else {
      // To check special charactor in url
      if (specialCharRegx.test(url)) {
        return false;
      } else {
        let str = https === "https://" ? string : string.replace("www.", "");
        return !!regx.test(str);
      }
    }
  }
};

export const getStorageKey = () => {
  const queryParam = new URLSearchParams(window.location.search);
  const hasJobId = queryParam.has("job_id");
  const storageKey = hasJobId ? "jobPostingSessionStorage" : "postJobsFields";
  const storage = hasJobId ? sessionStorage : localStorage;
  return { storage, storageKey };
};

export const setFieldValue = (fieldName, fieldValue) => {
  if (fieldName) {
    const { storageKey, storage } = getStorageKey();
    let postJobsFields = storage.getItem(storageKey)
      ? JSON.parse(storage.getItem(storageKey))
      : {};

    postJobsFields = postJobsFields ? postJobsFields : {};
    postJobsFields[fieldName] = fieldValue;
    storage.setItem(storageKey, JSON.stringify(postJobsFields));
    const cookieDomain = getCookieDomain();
    Cookies.set("isAutoSave", 1, {
      expires: 2,
      path: "/",
      ...(cookieDomain && { domain: cookieDomain })
    });
  }
};

export const jobPostingStorageExists = () => {
  const { storageKey, storage } = getStorageKey();
  const postJobsFields = storage.getItem(storageKey);
  return !!postJobsFields;
};

export const getFieldValue = fieldName => {
  const { storageKey, storage } = getStorageKey();
  const isAutoSave = Cookies.get("isAutoSave");
  if (isAutoSave) {
    if (storage.getItem(storageKey)) {
      let fieldsData = JSON.parse(storage.getItem(storageKey));
      fieldsData = fieldsData ? fieldsData : {};
      if (fieldsData && fieldsData[fieldName] !== "") {
        return fieldsData[fieldName];
      } else {
        return "";
      }
    } else {
      return "";
    }
  } else {
    deleteLocalStorage(storageKey, storage);
    return "";
  }
};

export const deleteLocalStorage = (storageKey, storage = localStorage) => {
  if (!storageKey) {
    sessionStorage.removeItem("jobPostingSessionStorage");
    localStorage.removeItem("postJobsFields");
  }
  storage.removeItem(storageKey);
  localStorage.removeItem("isAutoSave");
};

export const deepCopyFunction = inObject => {
  let outObject, value, key;

  if (typeof inObject !== "object" || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCopyFunction(value);
  }

  return outObject;
};

// Function to return string with blury

export const getBluryString = (type, string) => {
  // This function will return fields specific blury string in case of under review jobs.

  if (!string) return;
  let chunks = [];
  let arr = [];
  if (type === "languages") {
    chunks = string.split(/\s+/);
    arr = [chunks.shift(), chunks.join(" ")];
    return `${arr[0]} <span>${arr[1]}</span>`;
  }
  if (type === "address") {
    chunks = string.split(",");
    return `<span>${chunks[0]}</span>, ${chunks[1]} `;
  }
  if (type === "salary") {
    return `Earning <span>₹ 1,800 </span> monthly `;
  }
  if (type === "experience" || type === "industry") {
    chunks = string.split("in");
    return ` ${chunks[0]} in <span>${chunks[1]}</span>`;
  }
  if (type === "skills") {
    chunks = string.split(",");
    arr = [chunks.shift(), chunks.join(", ")];
    if (arr[1]) return `${arr[0]}, <span>${arr[1]}</span> `;
    else {
      chunks = string.split("in");
      return ` ${chunks[0]} in <span>${chunks[1]}</span>`;
    }
  }
};

export const getItemList = array => {
  if (array.length) {
    const arrayList = array.map(item => {
      return { label: item, value: item };
    });
    return arrayList;
  } else return array;
};

export const get50PerUsersCheck = recruiterId => {
  let isEven = false;
  if (recruiterId % 2 === 0) {
    isEven = true;
  }
  return isEven;
};

/**
 * Check if recruiter should be in a specific percentage bucket
 * @param {number|string} recruiterId - The recruiter ID
 * @param {number} percentage - Percentage of users (0-100)
 * @returns {boolean} - True if recruiter is in the percentage bucket
 */
export const getPercentageUsersCheck = (recruiterId, percentage) => {
  const id = Number(recruiterId);

  if (isNaN(id) || percentage <= 0 || percentage >= 100) {
    return false;
  }

  // For 20% bucket → RecId divisible by 20
  return Math.abs(id) % (100/20) === 0;
};

function comparator(a, b) {
  if (a.variable1 < b.variable1) {
    return -1;
  } else if (a.variable1 > b.variable1) {
    return 1;
  } else {
    if (a.variable2 < b.variable2) {
      return -1;
    } else if (a.variable2 > b.variable2) {
      return 1;
    } else {
      return 0;
    }
  }
}

export function getSearchResultList(dataList, searchKey) {
  let arryList = [];
  dataList.forEach(d => {
    const index = d.label.toLowerCase().indexOf(searchKey.toLowerCase());
    let wordIndex = 0;
    if (index !== -1) {
      for (let i = 0; i < index; i++) {
        if (d.label[i] === " ") {
          wordIndex++;
        }
      }
      arryList.push({
        ...d,
        score: { index, wordIndex }
      });
    }
  });
  arryList = arryList.sort((a, b) => {
    if (a.score.wordIndex < b.score.wordIndex) {
      return -1;
    } else if (a.score.wordIndex > b.score.wordIndex) {
      return 1;
    }
    if (a.score.index < b.score.index) {
      return -1;
    } else if (a.score.index > b.score.index) {
      return 1;
    } else {
      return 0;
    }
  });
  return arryList;
}

export function isPdfEncrypted(contents) {
  if (contents && contents.indexOf("/Encrypt") !== -1) {
    return true;
  } else {
    return false;
  }
}

export const getMinSecondFormat = seconds => {
  let sec = Math.ceil(seconds);
  var minutes = "0" + parseInt(sec / 60, 10);
  var seconds = "0" + parseInt(sec % 60);
  return minutes + ":" + seconds.slice(-2);
};

export const isEqual = (a, b, map = new Map()) => {
  if (a === b) return true;
  if (map.has(a) || map.has(b)) return true;
  map.set(a, b);
  if (typeof a === "object" && typeof b === "object") {
    const a_keys = Object.keys(a);
    const b_keys = Object.keys(b);
    if (a_keys.length !== b_keys.length) return false;
    for (let i = 0; i < a_keys.length; i++) {
      if (!isEqual(a[a_keys[i]], b[b_keys[i]], map)) return false;
    }
    return true;
  }
  return false;
};
export function formattedTabName(tab, closedEmptyStatePressed = false) {
  if (tab === "close_reject" && closedEmptyStatePressed) {
    return "close";
  }
  if (tab === "active" || tab === "") {
    return "live";
  } else if (tab === "review") {
    return "under_review";
  } else if (tab === "close") {
    return "close_reject";
  } else if (tab === "close_reject_archived") {
    return "close_reject_archived";
  }
}

let keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

// call this to Disable
export function disableScroll(wheelEvent, wheelOpt) {
  window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
  window.addEventListener("keydown", preventDefaultForScrollKeys, false);
}

// call this to Enable
export function enableScroll(wheelEvent, wheelOpt) {
  window.removeEventListener("DOMMouseScroll", preventDefault, false);
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
  window.removeEventListener("touchmove", preventDefault, wheelOpt);
  window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
}

export function activeTabFormat(tab) {
  let activeTab = "";
  if (tab == "live") {
    activeTab = "active";
  } else if (tab == "under_review") {
    activeTab = "review";
  } else if (tab == "close_reject") {
    activeTab = "close";
  }
  return activeTab;
}

export const getYouTubeId = url => {
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
};

export function formatCount(count = "") {
  const formattedCount =
    parseInt(count) > 0 && parseInt(count) < 10 ? `0${count}` : count;
  return formattedCount;
}

export const getPreloadFontsLinks = () => {
  return (
    <>
      <link
        rel="preload"
        href={`https://fonts.gstatic.com/s/sourcesanspro/v14/6xK3dSBYKcSV-LCoeQqfX1RYOo3qOK7lujVj9w.woff2`}
        as="font"
        type="font/woff2"
        crossorigin="anonymous"
      />
      <link
        rel="preload"
        href={`https://fonts.gstatic.com/s/sourcesanspro/v14/6xKydSBYKcSV-LCoeQqfX1RYOo3i54rwlxdu3cOWxw.woff2`}
        as="font"
        type="font/woff2"
        crossorigin="anonymous"
      />
      <link
        rel="preload"
        href={`https://fonts.gstatic.com/s/sourcesanspro/v14/6xKydSBYKcSV-LCoeQqfX1RYOo3ig4vwlxdu3cOWxw.woff2`}
        as="font"
        type="font/woff2"
        crossorigin="anonymous"
      />
    </>
  );
};

export const isOtherDocRequired = (profileData, isCheckEmail = true) => {
  const { is_other_doc_reqd = false } = profileData;
  const isOtherDocRequired = false;
  if (is_other_doc_reqd) {
    if (isCheckEmail) {
      return (
        getDocumentStatus(profileData) === "no_document" &&
        !shouldEmailVerify(profileData)
      );
    } else {
      return getDocumentStatus(profileData) === "no_document";
    }
  }
  return isOtherDocRequired;
};

export const generateMsg = details => {
  const {
    name,
    job_address,
    job_title,
    company_name,
    salary_text,
    landing_url,
    recruiterPhone,
    recruiterName,
    jobContactNumber
  } = details;
  const contactNumber = jobContactNumber ? jobContactNumber : recruiterPhone;
  let message = `Dear ${name} \nI found your profile on *Job Hai*. I have a vacancy for: \n\n*${job_title}* \n_Company_ - ${company_name} \n_Salary_ - *${salary_text} per month* \n_Location_ - ${job_address} \n\nMore Details - ${landing_url}\n\nPlease call me on "*${contactNumber}*"\n\n${recruiterName}`;
  message = encodeURIComponent(message);
  return message;
};

export const sendMessage = (phone, message, isMobile) => {
  if (phone && phone.length === 10) phone = `91${phone}`;
  let url = `${WHATSAPP_WEB_URL}?phone=${phone}&text=${message}`;
  if (isMobile) {
    url = `${WHATSAPP_URL}${phone}?text=${message}`;
  }
  let a = document.createElement("a");
  document.body.appendChild(a);
  a.target = isMobile ? "_self" : "_blank";
  a.style = "display: none";
  a.href = url;
  a.click();
  document.body.removeChild(a);
};

export function checkForPersonalEmail(email = "") {
  let includes = PERSONAL_EMAILS.some(v => email.toLowerCase().includes(v));
  return includes;
}

export const checkIsMobile = deviceType => {
  return deviceType === MOBILE_TYPE;
};

export const countAppliedFilters = filters => {
  let count = 0;
  filters.map(item => {
    if (item.is_selected) {
      count++;
    }
  });
  return count;
};

export const getSelectedFilterId = filterList => {
  let list = [];
  filterList.filter(item => {
    if (item.is_selected) {
      list.push(item.id);
    }
  });
  return list;
};

export const diffDays = (date1 = "", date2 = "") => {
  const diffTime = date2.getTime() - date1.getTime();
  return Math.ceil(diffTime / (1000 * 3600 * 24));
};

export const showClosedCmpView = currJobItem => {
  return (
    currJobItem.no_of_hired_candidates &&
    (currJobItem.status === CLOSED || currJobItem.status === EXPIRED)
  );
};

export const getKeyFromURL = key => {
  let url = "";
  if (typeof window !== "undefined") {
    url = window.location.search;
  }
  const urlParams = new URLSearchParams(url);
  return urlParams.get(key) || "";
};

export const getDateDiffFromToday = (dateFrom, format = "day") => {
  if (dateFrom) {
    const date = new Date();
    const currentDate = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
    // Find number of days from today to datefrom
    const daysDiff = dayjs(currentDate).diff(dayjs(dateFrom), format);
    return daysDiff;
  } else return false;
};

export const toHoursAndMinutes = totalMinutes => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${padToTwoDigits(hours)}:${padToTwoDigits(minutes)}`;
};

export const padToTwoDigits = num => {
  if (num) return num.toString().padStart(2, "0");
  else return "00";
};

/**
 * Calculates the next Monday date from the current date
 * If today is Monday, returns next week's Monday (7 days from now)
 * Otherwise returns the upcoming Monday
 * @returns {string} Formatted date string (e.g., "Monday, January 6, 2026")
 */
export const getNextMondayDate = () => {
  const today = dayjs();
  const dayOfWeek = today.day(); // 0=Sunday, 1=Monday, ..., 6=Saturday

  let daysUntilMonday;
  if (dayOfWeek === 0) {
    // If today is Sunday, next Monday is 1 day away
    daysUntilMonday = 1;
  } else if (dayOfWeek === 1) {
    // If today is Monday, return next week's Monday
    daysUntilMonday = 7;
  } else {
    // Calculate days until next Monday (Tuesday-Saturday)
    daysUntilMonday = 8 - dayOfWeek;
  }

  const nextMonday = today.add(daysUntilMonday, "day");
  return nextMonday.format("ddd, D MMM");
};

/**
 * Returns the appropriate message for basic job expiration based on date
 * After January 1, 2026, shows weekly message with next Monday date
 * Before January 1, 2026, shows monthly message
 * @returns {string} Message string for the popup
 */
export const getBasicJobExpiredMessage = () => {
  const cutoffDate = dayjs("2026-01-01 00:00:00");
  const today = dayjs();

  // Check if current date is on or after January 1, 2026 00:00:00
  if (today.valueOf() >= cutoffDate.valueOf()) {
    const nextMondayDate = getNextMondayDate();
    return `You've used your 1 basic job for this week. Basic Job next available on ${nextMondayDate}.`;
  }

  // Return monthly message for dates before January 1, 2026
  return "You have reached the limit of Basic Jobs for this month. Continue hiring with a Premium Job";
};

export const decideErrorCode = (error = {}, appendString = "") => {
  const { message = "" } = error;
  if (message.trim().toLowerCase() === "network error")
    return NETWORK_ERROR_CODE;
  if (appendString) return `${REC_ERROR_CODE}-${appendString}`;
  return REC_ERROR_CODE;
};

export function getDeviceInfo() {
  const navObj = typeof navigator === "undefined" ? null : navigator;
  const {
    connection = null,
    userAgent = "",
    deviceMemory = "",
    hardwareConcurrency
  } = navObj;
  const href = process.browser && location ? location.href : "";
  const { effectiveType, rtt, downlink } = connection || {};
  const conn = connection
    ? {
        effectiveType: effectiveType,
        rtt: rtt,
        downlink: downlink
      }
    : undefined;
  return {
    url: href,
    referrer: process.browser && document ? document.referrer : null,
    cookie: process.browser && document ? document.cookie : null,
    userAgent,
    memory: deviceMemory ? deviceMemory : undefined,
    cpus: hardwareConcurrency ? hardwareConcurrency : undefined,
    deviceWidth: navObj ? window.innerWidth : undefined,
    deviceHeight: navObj ? window.innerHeight : undefined,
    connection: conn
  };
}

export function getRndInteger(min = 1, max = 1000) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export function isObject(val) {
  return typeof val === "object" && val !== null;
}

export function removeEmojis(string) {
  const emojiRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  return string.replace(emojiRegex, "");
}

export const MOENGAGE_SCRIPT = `
!function(e,n,i,t,a,r,o,d){var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js","Moengage");
Moengage = moe({
app_id: "${process.env.MOENGAGE_ID}",
debug_logs: 0,
cluster: "DC_3",
swPath:"/hire/rec-sw.js"
});
`;

export const CLARITY_SCRIPT = `
(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "jcusn4pz9q");
`;

export const FB_PIXEL_SCRIPT = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${FB_PIXEL_ID}');
fbq('track', 'PageView');
`;

export const getJobEligibilityDataObj = jobPostEligibilityData => {
  const {
    free_job_count_available = null,
    paid_job_count_available = null,
    can_post,
    free_job_left_threshold_count = 5,
    paid_job_left_threshold_count = 5,
    isPaidJobHardCheck = false
  } = jobPostEligibilityData;
  const isPaidJob = isPaidJobHardCheck || !!paid_job_count_available; // setting paid job check in case of isPaidJobHardCheck as true.
  const jobLimitHeaderCondition = can_post
    ? (free_job_count_available !== null &&
        free_job_count_available <= free_job_left_threshold_count) ||
      isPaidJob
    : false;
  const showJobTypeHeading = isPaidJobHardCheck || jobLimitHeaderCondition; // setting jobtypeheader visibility check in case isPaidJobHardCheck as true

  let jobTypeIcon = "";

  if (isPaidJob) {
    if (paid_job_count_available <= paid_job_left_threshold_count) {
      jobTypeIcon = "/hire/paid-job-icon.svg";
    } else {
      jobTypeIcon = "/hire/paid-job-icon-green.svg";
    }
  } else {
    jobTypeIcon = "/hire/free-job-icon.svg";
  }
  let jobTypeCntBackground = "";

  if (isPaidJob) {
    if (paid_job_count_available <= paid_job_left_threshold_count) {
      jobTypeCntBackground = "#FFF0F0";
    } else {
      jobTypeCntBackground = "#DAFFE2";
    }
  } else {
    jobTypeCntBackground = "#F6F9FF";
  }

  const jobLeftCount = isPaidJob // in case of isPaidJobHardCheck it will be 0.
    ? paid_job_count_available
    : free_job_count_available;

  return {
    isPaidJob,
    showJobTypeHeading,
    jobTypeIcon,
    jobTypeCntBackground,
    jobLeftCount
  };
};

export const renderPluralString = (count, string) => {
  if (count > 1 || count === 0) {
    return `${string}s`;
  }
  return string;
};

export const checkCacheAvailable = () => {
  try {
    localStorage;
    return true;
  } catch (err) {
    return false;
  }
};

export const checkFreeTextValidation = value => {
  if (!value) return false;
  if (value?.length > 30) return false;
  const regex = /^[a-zA-Z0-9 \-/]+$/;
  return regex.test(value);
};

export function isErrorNonReproducible(message) {
  const inValidMsgList = [
    "Cannot read properties of null (reading 'getItem')",
    "Cannot read properties of null (reading 'cuid')",
    "null is not an object (evaluating 'i._id')",
    "Cannot read properties of null (reading 'cuid')",
    "Cannot read property 'getItem' of null",
    "null is not an object (evaluating 'i._id')",
    "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
    "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
    "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document."
  ];
  if (message) return inValidMsgList.includes(message);
  return true;
}

export function getNoCandidatesViewObj({
  isReviewTab,
  appliedFilterCount,
  activeSubTab,
  tabId,
  onReviewClick,
  handleShare,
  toggleFilterSheet
}) {
  const noCandidatesViewProps = {
    imgUrl: "/hire/review-tab-no-candidates.svg",
    heading: "Zero Candidates Found",
    subheading: `<b>Share</b> this job to get more candidates`,
    primaryCtaText: "Share",
    secondaryCtaText: ""
  };
  if (!isReviewTab) {
    noCandidatesViewProps.primaryCtaText = "Review Candidates";
    noCandidatesViewProps.subheading = "";
    noCandidatesViewProps.secondaryCtaText = "";
  }
  if (appliedFilterCount) {
    noCandidatesViewProps.subheading = "";
    noCandidatesViewProps.secondaryCtaText = "";
    noCandidatesViewProps.primaryCtaText = "Remove filters";
  } else if (isReviewTab && activeSubTab === DIRECT_APPLIES) {
    noCandidatesViewProps.imgUrl = "/hire/direct-applies-no-cand.svg";
    noCandidatesViewProps.heading = "Zero Direct Applies";
  } else if (isReviewTab && activeSubTab === DATABASE_MATCHES) {
    noCandidatesViewProps.imgUrl = "/hire/database-match-no-cand.svg";
    noCandidatesViewProps.heading = "Zero Database Matches";
    noCandidatesViewProps.primaryCtaText = "Review Candidates";
    noCandidatesViewProps.secondaryCtaText = "";
    noCandidatesViewProps.subheading = "";
  } else if (tabId === ACTIONED) {
    noCandidatesViewProps.imgUrl = "/hire/contacted-tab-no-cand.svg";
    noCandidatesViewProps.heading = "Zero Contacted Candidates";
  } else if (tabId === HIRED) {
    noCandidatesViewProps.imgUrl = "/hire/hired-tab-no-cand.svg";
    noCandidatesViewProps.heading = "Zero Hired Candidates";
  } else if (tabId === REJECTED) {
    noCandidatesViewProps.imgUrl = "/hire/reject-tab-no-cand.svg";
    noCandidatesViewProps.heading = "Zero Removed Candidates";
  }
  if (noCandidatesViewProps.primaryCtaText === "Review Candidates") {
    noCandidatesViewProps.primaryOnCtaClick = () => onReviewClick();
  } else if (noCandidatesViewProps.primaryCtaText === "Remove filters") {
    noCandidatesViewProps.primaryOnCtaClick = () => toggleFilterSheet(true);
  } else if (noCandidatesViewProps.primaryCtaText === "Share") {
    noCandidatesViewProps.primaryOnCtaClick = () => handleShare();
  }
  return noCandidatesViewProps;
}

export const singleSelectChipLogic = ({
  valueKey,
  panel,
  chipObject,
  chipValue,
  data
}) => {
  const tempData =
    !data.filter(item => item[valueKey] === chipValue).length > 0
      ? [
          ...data.filter(item => item.panel !== panel),
          { panel: panel, ...chipObject }
        ]
      : [];

  return tempData;
};

export function addEmailAndMobileLinks(string) {
  // Regular expression to match email addresses
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;

  // Regular expression to match 10-digit mobile numbers
  const mobileRegex = /\d{10}/;

  // Replace email addresses with anchor tags
  let modifiedString = string.replace(emailRegex, function (match) {
    return (
      '<a target="_blank" rel="noopener noreferrer" id="email" href="mailto:' +
      match +
      '">' +
      match +
      "</a>"
    );
  });

  // Replace 10-digit mobile numbers with bold tags
  modifiedString = modifiedString.replace(mobileRegex, function (match) {
    return "<b id='phone' >" + match + "</b>";
  });

  return modifiedString;
}

export function createNumbersArray(n) {
  const resultArray = Array.from({ length: n }, (_, index) => index);
  return resultArray;
}

export const checkPremiumJob = item => {
  const { jobPlan = "" } = item;
  return jobPlan === PREMIUM_JOB;
};

export const generateCombinations = (arr, k) => {
  const results = [];
  function backtrack(tempCombination, start) {
    if (tempCombination.length === k) {
      results.push(encodeCohortRestrictionData(tempCombination));
      return;
    }
    for (let i = start; i < arr.length; i++) {
      tempCombination.push(arr[i]);
      backtrack(tempCombination, i + 1);
      tempCombination.pop();
    }
  }

  backtrack([], 0);

  return results;
};

export const encodeCohortRestrictionData = data => {
  return data.join("_");
};

export const decodeCohortRestrictionData = data => {
  return data.split("_");
};

export function throttle(func, delay) {
  // this was made to only allow the most oldest call of a function within the time given delay
  let timeout;
  return function (...args) {
    const context = this;
    if (!timeout) {
      func.apply(context, args);
      timeout = setTimeout(() => {
        timeout = null;
      }, delay);
    }
  };
}

export function reverseThrottle(func, delay) {
  // this was made to only allow the most latest call of a function within the time given delay
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

export const getContactSalesInfo = ({
  contactObj = {},
  isMobile,
  contactSalesClicked
}) => {
  // this function returns an object of href,cta text and if the user is in restricted hour(post 6:30pm)
  // the cta text will change acc to the restricted hour i.e before restrcited hour calling option is given and after that email option is given.
  // for desktop we also check if the CTA is clicked to show email id and contact number acc to the restrcited hour check.
  // this function is used for job limit CTAs on job posting block screen and dashboard contact sales CTA.
  const {
    is_restricted_hour: isRestrictedHour = false,
    contact_number: contactNumber,
    formatted_contact_number: formattedContactNumber,
    call_cta_text: callCtaText,
    email_cta_text: emailCtaText,
    to,
    subject,
    body,
    cc
  } = contactObj || {};
  let contactSalesText = isRestrictedHour ? emailCtaText : callCtaText;
  if (contactSalesClicked && !isMobile)
    contactSalesText = isRestrictedHour
      ? contactObj.to
      : formattedContactNumber;
  const contactSalesHref = isRestrictedHour
    ? `mailto:${to}?cc=${cc}&subject=${subject}&body=${body}`
    : isMobile
    ? `tel:${contactNumber}`
    : null;

  return {
    contactSalesHref,
    contactSalesText,
    isRestrictedHour
  };
};

/**
 * Get contact sales info for JobPostEligibilityData (camelCase format)
 * This function works with the camelCase emailContactInformation from JobPostEligibilityData interface
 * @param {Object} params - Parameters object
 * @param {Object} params.emailContactInformation - Email contact information in camelCase format
 * @param {boolean} params.isMobile - Whether the device is mobile
 * @param {boolean} params.contactSalesClicked - Whether the contact sales button was clicked
 * @returns {Object} Object containing contactSalesHref, contactSalesText, and isRestrictedHour
 */
export const getContactSalesInfoForEligibility = ({
  emailContactInformation = {},
  isMobile,
  contactSalesClicked
}) => {
  // This function returns an object of href, cta text and if the user is in restricted hour (post 6:30pm)
  // The cta text will change according to the restricted hour i.e before restricted hour calling option is given and after that email option is given.
  // For desktop we also check if the CTA is clicked to show email id and contact number according to the restricted hour check.
  // This function is used for job limit CTAs on job posting block screen with camelCase JobPostEligibilityData format.
  const {
    isRestrictedHour = false,
    contactNumber,
    formattedContactNumber,
    callCtaText,
    emailCtaText,
    to,
    subject,
    body,
    cc
  } = emailContactInformation || {};

  let contactSalesText = isRestrictedHour ? emailCtaText : callCtaText;
  if (contactSalesClicked && !isMobile)
    contactSalesText = isRestrictedHour
      ? emailContactInformation.to
      : formattedContactNumber;

  const contactSalesHref = isRestrictedHour
    ? `mailto:${to}?cc=${cc}&subject=${subject}&body=${body}`
    : isMobile
    ? `tel:${contactNumber}`
    : null;

  return {
    contactSalesHref,
    contactSalesText,
    isRestrictedHour
  };
};
export const numberWithCommas = number => {
  try {
    if (number !== null && number !== undefined) {
      const formattedCurrency = new Intl.NumberFormat("en-IN", {
        currency: "INR"
      }).format(number);
      return formattedCurrency;
    } else return null;
  } catch (e) {
    return number;
  }
};
const jpErrors = {
  field_openings: { key: "id_openings", attr: "id", strategy: "custom" },
  field_city: { key: "id_city", attr: "id", strategy: "custom" },
  field_title: { key: "id_title", attr: "id", strategy: "custom" },
  field_category: { key: "id_category", attr: "id", strategy: "custom" },
  field_locality: { key: "id_locality", attr: "id", strategy: "custom" },
  field_gender: { key: "id_gender", attr: "id", strategy: "custom" },
  field_qualification: { key: "qual-min", attr: "id", strategy: "custom" },
  field_min_salary: { key: "id_salary", attr: "id", strategy: "custom" },
  field_max_salary: { key: "id_salary", attr: "name", strategy: "custom" },
  field_incentive: { key: "id_salary", attr: "id", strategy: "custom" },
  field_add_fee: { key: "id_addFee", attr: "id", strategy: "custom" },
  field_industry_type: { key: "id_industry", attr: "id", strategy: "custom" },
  field_experience: { key: "id_experience", attr: "id", strategy: "custom" },
  field_working_days: {
    key: "id_working_days",
    attr: "id",
    strategy: "custom"
  },
  field_amount: { key: "id_amount", attr: "id", strategy: "custom" },
  field_fee_reason: { key: "id_reason", attr: "id", strategy: "custom" },
  field_fee_time: { key: "id_fee_time", attr: "id", strategy: "custom" },
  field_suggestedJD: {
    key: "id_suggestedJD",
    attr: "id",
    strategy: "custom"
  },
  field_skill: { key: "id_skills", attr: "id", strategy: "custom" },
  field_job_timings: { key: "id_timing", attr: "id", strategy: "custom" },
  field_shift_type: { key: "id_shift", attr: "id", strategy: "custom" },
  field_work_location: {
    key: "work_location",
    attr: "id",
    strategy: "custom"
  }
};
export const focusOnDuplicate = ({
  isSalaryFocus = false,
  isOpeningFocus = false,
  isExperienceFocus
}) => {
  let a = null;
  if (isSalaryFocus) {
    a = {
      field_min_salary: { key: "id_salary", attr: "id", strategy: "custom" }
    };
  }
  if (isOpeningFocus) {
    a = {
      field_openings: { key: "id_openings", attr: "id", strategy: "custom" }
    };
  }
  if (isExperienceFocus) {
    a = {
      field_experience: { key: "id_experience", attr: "id", strategy: "custom" }
    };
  }
  if (a) {
    setTimeout(() => {
      jobPostingErrorFocus(a);
    }, 500);
  }
};

export const jobPostingErrorFocus = errorFlds => {
  try {
    const keys = Object.keys(errorFlds);

    let mappedValue = null;
    for (let i = 0; i < keys.length; i++) {
      mappedValue = jpErrors[keys[i]];
      if (mappedValue) {
        break;
      }
    }

    if (mappedValue) {
      if (mappedValue.strategy === "custom") {
        const elm = document.getElementById(mappedValue.key);
        const headerHeight =
          document.getElementById("header-root").offsetHeight;

        const position =
          elm.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top: position - 48, behavior: "smooth" });
        //the 48 is actually to bring the item into view. item was in view with 20 also but posting form has agreen banner due to which 48 is needed

        return;
      }
      // if (mappedValue?.attr === "id") {
      //   const elm = document.getElementById(mappedValue.key);
      //   console.log("eee", elm);
      //   if (elm) elm.focus();
      // }
      // if (mappedValue.attr === "name") {
      //   const [elm] = document.getElementsByName(mappedValue.key);
      //   if (elm) {
      //     elm.focus();
      //   }
      // }
    }
  } catch (err) {
    reportException({
      error: err,
      errorCode: "SCROLL-POSTING"
    });
  }
};

export const unregisterExistingSw = ({ scope }) => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(function (registrations) {
        for (let registration of registrations) {
          if (registration.scope === scope)
            registration.unregister().then(function (success) {
              if (success) {
                console.log(
                  "Service worker unregistered successfully:",
                  registration.scope
                );
              } else {
                console.log(
                  "Service worker unregistration failed:",
                  registration.scope
                );
              }
            });
          else {
            console.log("Service worker not found", scope);
          }
        }
      })
      .catch(function (error) {
        console.error("Error getting service worker registrations:", error);
      });
  }
};

function checkJobInRestrictedCohort() {
  const { recruiter_onboarded_date } = profileData;
  if (!recruiter_onboarded_date) return {}; // will restrict only onboarded recruiters
  const { job_city_id, category_id, job_locality_id } =
    payload.jobPostingData.jobDetails;
  const modifiedJobDetails = {
    ...payload.jobPostingData.jobDetails,
    cityId: job_city_id,
    categoryId: category_id,
    localityId: job_locality_id
  };
  let restrictedCohortData = {};
  for (let i = 0; i < totalKeyCombinations.length; i++) {
    for (let formattedKey of totalKeyCombinations[i]) {
      const keyArr = decodeCohortRestrictionData(formattedKey);
      let resultValue = [];
      keyArr.forEach(key => {
        if (modifiedJobDetails.hasOwnProperty(key)) {
          resultValue.push(modifiedJobDetails[key]);
        }
      });
      const encodedResultValue = encodeCohortRestrictionData(resultValue);
      if (cohortLimitData.hasOwnProperty(encodedResultValue)) {
        restrictedCohortData = cohortLimitData[encodedResultValue];
        return restrictedCohortData; //returning from the whole function here
      }
    }
  }
  return restrictedCohortData;
}
export const getTimeAgo = (date, prefix = "") => {
  const now = new Date();
  const dbDate = new Date(date);
  const diffInSeconds = Math.floor((now - dbDate) / 1000);

  const years = Math.floor(diffInSeconds / (60 * 60 * 24 * 365));
  if (years > 0) return `${prefix} ${years} year${years > 1 ? "s" : ""} ago`;

  const months = Math.floor(diffInSeconds / (60 * 60 * 24 * 30));
  if (months > 0)
    return `${prefix} ${months} month${months > 1 ? "s" : ""} ago`;

  const days = Math.floor(diffInSeconds / (60 * 60 * 24));
  if (days > 0) return `${prefix} ${days} day${days > 1 ? "s" : ""} ago`;

  const hours = Math.floor(diffInSeconds / (60 * 60));
  if (hours > 0) return `${prefix} ${hours} hour${hours > 1 ? "s" : ""} ago`;

  const minutes = Math.floor(diffInSeconds / 60);
  if (minutes > 0)
    return `${prefix} ${minutes} minute${minutes > 1 ? "s" : ""} ago`;

  return `${prefix} ${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""} ago`;
};

export const isSaleActive = () => {
  // Define the start and end dates for the sale
  const saleStart = new Date("2024-12-24T23:59:59");
  const saleEnd = new Date("2025-01-02T00:00:00");

  // Get the current date and time
  const now = new Date();

  // Check if the current time is within the sale period
  return now >= saleStart && now < saleEnd;
};
